import React, { useState } from 'react';
import { LuContact2 } from 'react-icons/lu';
import logo from '../../assets/logo.svg';
import { Divider } from '@jobber/components/Divider';
import { Link, useLocation } from 'react-router-dom';
import { MdRequestQuote, MdSpaceDashboard, MdSpeakerNotes } from 'react-icons/md';
import { IoSettingsSharp } from 'react-icons/io5';
import { BsSuitcaseLgFill } from 'react-icons/bs';
import { FaCalendarDays, FaPaperclip } from 'react-icons/fa6';
import { MdPriceChange } from "react-icons/md";
import { usePermission } from '../../hooks/use-permission';
import { ROUTE_PERMISSIONS } from '../../config/permissions';

const menuItems = [
	{
		icon: <MdSpaceDashboard className="fw-bold fs-5" />,
		to: '/dashboard',
		label: 'Dashboard',
		permissions: ROUTE_PERMISSIONS.dashboard,
	},
	{
		icon: <LuContact2 className="fw-bold fs-5" />,
		to: '/clients',
		label: 'Clients',
		permissions: ROUTE_PERMISSIONS.clients,
	},
	{
		icon: <MdRequestQuote className="fw-bold fs-5" />,
		to: '/advance-quotes',
		label: 'Advance Quotes',
		permissions: ROUTE_PERMISSIONS.quotes,
	},
	{
		icon: <MdRequestQuote className="fw-bold fs-5" />,
		to: '/quotes-prep',
		label: 'Quotes Preparation',
		permissions: ROUTE_PERMISSIONS.quotesPreparation,
	},
	{
		icon: <MdRequestQuote className="fw-bold fs-5" />,
		to: '/draft-quotes',
		label: 'Quotes Fix',
		permissions: ROUTE_PERMISSIONS.quoteFix,
	},
	{
		icon: <FaCalendarDays className="fw-bold fs-5" />,
		to: '/advance-visits',
		label: 'Advance Visits',
		permissions: ROUTE_PERMISSIONS.visits,
	},
	{
		icon: <FaCalendarDays className="fw-bold fs-5" />,
		to: '/visits-map',
		label: 'Visits Map',
		permissions: ROUTE_PERMISSIONS.visits,
	},
	{
		icon: <BsSuitcaseLgFill className="fw-bold fs-5" />,
		to: '/job-automation',
		label: 'Job Automation',
		permissions: ROUTE_PERMISSIONS.jobAutomation,
	},
	{
		icon: <MdPriceChange className="fw-bold fs-5" />,
		to: '/approved-quotes',
		label: 'Approved Quotes',
		permissions: ROUTE_PERMISSIONS.approvedQuotes,
	},
	// {
	// 	icon: <FaRecycle className="fw-bold fs-5" />,
	// 	to: "/recycle-quotes",
	// 	label: "Recycle Quotes",
	// },
	{
		icon: <MdSpeakerNotes className="fw-bold fs-5" />,
		to: '/advance-notes',
		label: 'Advance Notes',
		permissions: ROUTE_PERMISSIONS.notes,
	},
	{
		icon: <FaPaperclip className="fw-bold fs-5" />,
		to: 'https://commission.theroyalgateway.com',
		external: true,
		label: 'Commission'
	},
	// {
	// 	icon: <BsSuitcaseLgFill className="fw-bold fs-5" />,
	// 	to: "/jobs",
	// 	label: "Closed Jobs",
	// },
	{
		icon: <IoSettingsSharp className="fw-bold fs-5" />,
		to: '/settings',
		label: 'Settings',
		permissions: ROUTE_PERMISSIONS.settings,
	}
];

function Sidebar() {
	const location = useLocation();
	const { hasPermissions, isLoading } = usePermission();

	const visibleMenuItems = menuItems.filter((item) => {
		if (!item.permissions) {
			return true;
		}

		if (isLoading) {
			return false;
		}

		return hasPermissions(item.permissions);
	});
	return (
		<div className="sidebar">
			<div className="l-navbar show sidebarmenu overflow-auto" id="nav-bar">
				<nav className="nav">
					<div className="fw-bold">
						<a href="#" className="nav_logo">
							<i className="bx bx-layer nav_logo-icon"></i>{' '}
							<span className="nav_logo-name">
								<img src={logo} alt="" />
							</span>
						</a>
						<div className="nav_list">
							{visibleMenuItems &&
								visibleMenuItems?.map((item) => {
									if (item.external) {
										return (
											<a
												key={item.to}
												href={item.to}
												target="_blank"
												className="nav_link"
											>
												{item.icon}
												<span className="nav_name">{item.label}</span>
											</a>
										);
									}
									return location.pathname == item.to ? (
										<span key={item.to} className={`pointer nav_link disabled ${location.pathname == item.to ? 'active' : ''}`}>
											{item.icon}
											<span className="nav_name">{item.label}</span>
										</span>
									) : (
										<Link key={item.to} to={item.to} className={`nav_link ${location.pathname == item.to ? 'active' : ''}`}>
											{item.icon}
											<span className="nav_name">{item.label}</span>
										</Link>
									);
								})}
						</div>
					</div>
				</nav>
			</div>
		</div>
	);
}

export default Sidebar;
